import React from "react";
import PageHeader from "presentation/pages/layout/elements/page-header";
import { Container, Row, Col, Table, Button, Form } from "react-bootstrap";
import { Link } from "react-router-dom";

import { connect } from "react-redux";

import PageLoadingIndicator from "presentation/components/page-loading-indicator";
import PageAlert from "presentation/components/page-alert";
import PageModal from "presentation/components/page-modal";

import CancelButton from "presentation/components/buttons/cancel";
import AddButton from "presentation/components/buttons/add";


import AddCoursesDisciplinesModal from "presentation/pages/course-disciplines/add-modal";
import ManageJointDisciplinesModal from "presentation/pages/course-disciplines/manage-joint-discipline-modal";
import ManageDisciplineModal from "presentation/pages/course-disciplines/manage-discipline-modal";

import { handleResultData } from "presentation/utils/functions/generic";

import coursesService from "presentation/services/courses";
import courseDisciplinesService from "presentation/services/course-disciplines";
import jointDisciplinesService from "presentation/services/joint-disciplines";

class CourseDisciplineMain extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      actionLoading: false,
      error: false,
      message: '',
      data: [],
      jointDisciplines: [],
      academicPeriods: [],
      course: {
        name: '',
        academicPeriodId: null
      },
      discipline: {},
      jointDiscipline: {},
      showConfirmModal: false,
      showAddDisciplineModal: false,
      showManageDisciplineModal: false,
      showManageJointDisciplineModal: false,
      targetDeleteId: null,
    };
    this.loadData = this.loadData.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeManageJointDisciplineModal = this.closeManageJointDisciplineModal.bind(this);
    this.deleteItem = this.deleteItem.bind(this);
  }

  async componentDidMount() {
    await this.loadData();
  }

  async componentDidUpdate(prevProps, prevState) {
    const { sessionParams } = this.props;
    const { sessionParams: previousSessionParams } = prevProps;

    if (sessionParams.currentAcademicPeriod != previousSessionParams.currentAcademicPeriod) {
      await this.loadData();
    }
  }

  loadData = async () => {
    const { id } = this.props.match.params
    const { sessionParams } = this.props;
    if (sessionParams.currentAcademicPeriod) {
      await coursesService.findById(id).then((result) => {
        let handledResult = handleResultData(result);

        this.setState({ course: handledResult }, () => { this.loadDisciplines(); this.loadJointDisciplines(); });
      });
    } else {
      this.setState({ error: true, loading: false, message: "Não foi possível carregar as informações do curso..." });
    }
  }

  loadDisciplines = async () => {
    const { id } = this.props.match.params
    let { course } = this.state;
    if (course.academicPeriodId) {
      await courseDisciplinesService.search({ courseId: [parseInt(id)], academicPeriodId: [parseInt(course.academicPeriodId)] }).then((result) => {
        let handledResult = handleResultData(result);
        this.setState({ data: handledResult, loading: false });
      });
    }

  }

  loadJointDisciplines = async () => {
    const { id } = this.props.match.params
    let { course } = this.state;
    if (course.academicPeriodId) {
      await jointDisciplinesService.search({ courseId: [parseInt(id)], academicPeriodId: [parseInt(course.academicPeriodId)] }).then((result) => {
        let handledResult = handleResultData(result);

        let finalResult = handledResult.map((fr, fri) => {
          var jointDisciplineItems = fr.jointDisciplineItems?.map((j, ji) => {
            return j.discipline;
          });

          let disciplineIds = jointDisciplineItems.map((jdi, jdii) => {
            return jdi.id;
          });

          let names = jointDisciplineItems.map((jdi, jdii) => {
            return jdi.name;
          });

          fr.disciplineId = disciplineIds;
          fr.disciplinesNames = names.join(", ");
          return fr;
        });

        this.setState({ jointDisciplines: finalResult, loading: false });
      });
    }

  }

  openModal = (id) => {
    this.setState({ targetDeleteId: id, showConfirmModal: true });
  }

  closeModal = () => {
    this.setState({ showConfirmModal: false, targetDeleteId: null });
  }

  openAddDisciplineModal = () => {
    this.setState({ showAddDisciplineModal: true });
  }

  closeAddDisciplineModal = () => {
    this.setState({ showAddDisciplineModal: false });
  }

  openManageJointDisciplineModal = (jointDiscipline = {}) => {
    this.setState({ showManageJointDisciplineModal: true, jointDiscipline: jointDiscipline });
  }

  closeManageJointDisciplineModal = () => {
    this.setState({ showManageJointDisciplineModal: false, jointDiscipline: {} });
  }

  openManageDisciplineModal = (discipline = {}) => {
    this.setState({ showManageDisciplineModal: true, discipline: discipline });
  }

  closeManageDisciplineModal = () => {
    this.setState({ showManageDisciplineModal: false, discipline: {} });
  }

  deleteItem = () => {
    const { loadDisciplines } = this;
    if (this.state.targetDeleteId) {
      this.setState({ loading: true, actionLoading: true });
      courseDisciplinesService.remove(this.state.targetDeleteId).then((result) => {
        this.setState({ loading: false, actionLoading: false, targetDeleteId: null, showConfirmModal: false }, () => {
          loadDisciplines();
        });
      });
    }
  }

  render() {
    const { id } = this.props.match.params;

    const { loading, actionLoading, error, message, data, jointDisciplines, showConfirmModal, showAddDisciplineModal, showManageJointDisciplineModal, showManageDisciplineModal, course, discipline, jointDiscipline } = this.state;

    const { deleteItem, closeModal, openModal, openAddDisciplineModal, closeAddDisciplineModal, openManageJointDisciplineModal, closeManageJointDisciplineModal, openManageDisciplineModal, closeManageDisciplineModal, loadDisciplines, loadJointDisciplines } = this;

    return (
      <div>
        {loading === true && <PageLoadingIndicator loadingText={actionLoading ? "Por favor, aguarde..." : "Carregando informações..."} />}
        {loading === false && error === true && <PageAlert className="m-b-20" message={"Erro"} description={message} type="danger" />}
        {loading === false && error === false && data.length <= 0 && <PageAlert className="m-b-20" message={"Sem informações"} description={"Não há dados para exibir no momento..."} type="info" dismissible />}
        {loading === false && (
          <Container>
            <Row>
              <h4>Matriz curricular do curso {course.name}
                <AddButton
                  containerProps={{
                    onClick: () => openAddDisciplineModal()

                  }}
                />
              </h4>
              <Container>
                <Row>
                  <Col>
                    <Table className="mt-4">
                      <thead>
                        <tr>
                          <th>Disciplina</th>
                          <th>Carga horária</th>
                          <th>Reprova?</th>
                          <th>Rótulo de resultado</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.length > 0 && data.map((element, index) => {
                          return (
                            <tr key={element.id}>
                              <td>{element.discipline.name}</td>
                              <td>{element.totalScheduledHours}</td>
                              <td>{element.ignoredInEvaluationSchemeCriterias ? "Não" : "Sim"}</td>
                              <td>{element.evaluationResultLabel?.name}</td>
                              <td className="text-end">
                                <Button variant="outline-secondary" onClick={() => openManageDisciplineModal(element)}>Editar</Button>
                                <Button variant="outline-secondary" onClick={() => openModal(element.id)}>Remover</Button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
                <Row>
                  <Col className="mt-3" xs={12}>
                    <h4>Disciplinas compostas</h4>
                    <AddButton
                      containerProps={{
                        onClick: () => openManageJointDisciplineModal()

                      }}
                    />
                  </Col>
                  <Col>
                    <Table className="mt-4">
                      <thead>
                        <tr>
                          <th>Nome de exibição</th>
                          <th>Composta por</th>
                          <th>É avaliada por disciplina</th>
                          <th>Rótulo de resultado</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {jointDisciplines.length > 0 && jointDisciplines.map((element, index) => {
                          return (
                            <tr key={element.id}>
                              <td>{element.name}</td>
                              <td>{element.disciplinesNames}</td>
                              <td>{element.allowIndividualFailure ? "Sim" : "Não"}</td>
                              <td>{element.evaluationResultLabel?.name}</td>
                              <td className="text-end">
                                <Button variant="outline-secondary" onClick={() => openManageJointDisciplineModal(element)}>Editar</Button>
                                <Button variant="outline-secondary" onClick={() => openModal(element.id)}>Remover</Button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Container>
              <div className="mt-3">
                <CancelButton
                  containerProps={{
                    as: Link,
                    to: `/cursos`
                  }}
                />
              </div>
            </Row>
            <AddCoursesDisciplinesModal
              show={showAddDisciplineModal}
              onClose={closeAddDisciplineModal}
              loadData={loadDisciplines}
              entityId={id}
              academicPeriodId={course.academicPeriodId}
              entityName={course.name}
            />
            {showManageJointDisciplineModal == true && (
              <ManageJointDisciplinesModal
                show={showManageJointDisciplineModal}
                onClose={closeManageJointDisciplineModal}
                loadData={loadJointDisciplines}
                courseId={id}
                academicPeriodId={course.academicPeriodId}
                entityName={course.name}
                disciplines={data}
                jointDiscipline={jointDiscipline}
              />
            )}
            {showManageDisciplineModal == true && (
              <ManageDisciplineModal
                show={showManageDisciplineModal}
                onClose={closeManageDisciplineModal}
                loadData={loadDisciplines}
                courseId={id}
                discipline={discipline}
              />)}
            <PageModal
              show={showConfirmModal}
              onClose={closeModal}
              onConfirm={deleteItem} />
          </Container>
        )}
      </div>
    );
  };
}
//Configs Redux para este component
//
//Define quais atributos vou pegar do
//state do Redux
const mapStateToProps = (state) => {
  const { data } = state.sessionParams;
  return { sessionParams: data };
};


//Define quais ações esse component
//vai usar para interagir com o Redux
const mapDispatchToProps = null;

export default connect(mapStateToProps, mapDispatchToProps)(CourseDisciplineMain);
